<template>
    <section class="map-balloon d-flex">
      <figure class="map-balloon__img">
          <img :src="building.preview" v-if="building.preview" height="110px">
          <img src="/assets/common/images/no-image-icon.jpg" height="110px" v-else>
      </figure>
        <div class="map-balloon__content">

            <h4 class="map-balloon__title">
                <a :href="'/novostroyki/' + building.slug" class="map-balloon__link" target="_blank">
                    ЖК «{{building.name}}»
                </a>
            </h4>
            <div class="map-balloon__status">
                <label class="mb-0" >Статус:</label> <span class="map-balloon__status-value" :class="'map-balloon__status-value--'+ building.status">{{building.status_title}}</span>
            </div>
            <div class="mb-1">
                <label class="mb-0">Район:</label> <a  v-if= "building.district" :href="'/city-filter/' + building.district.slug" class="map-balloon__district" target="_blank">{{building.district.name}}</a>
            </div>
          <a :href="'/novostroyki/' + building.slug" class="btn btn--small button-transparent-red mt-3">Подробнее о ЖК</a>

        </div>
    </section>
</template>
<script>
    export default {
        props: {
            building: {
                type: Object,
            }
        }
    }
</script>
